import React from "react";
import "./Header.css";
import { useNavigate, useLocation } from "react-router-dom";
 
import ktplLogo from "../../assets/1.png";
import starLogo from "../../assets/2.png";
import iworkkzWordmark from "../../assets/iWORKKZ-White 3.png";
 
import { useAuthStore } from "../../store/authStore";
import UserAvatar from "../desktop/UserAvatar";
 
const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
 
  const { user } = useAuthStore();
 
  const companyId = user?.company_id;
 
  const companyLogo = {
    1: ktplLogo,
    2: starLogo,
  }[companyId];
 
  const employeeName = `${user?.first_name || ""} ${user?.last_name || ""}`.trim();
 
  const basePath = location.pathname.startsWith("/admin/mobile")
    ? "/admin/mobile"
    : "/user/mobile";
 
  return (
    <header className="header">
      {/* LOGOS */}
      <div className="header-brand">
        {companyLogo && (
          <>
            <img src={companyLogo} alt="Company Logo" className="header-logo" />
            <span className="header-brand-divider" />
          </>
        )}
 
        <div className="header-powered">
          <span className="header-powered-label">Powered by</span>
          <span
            className="header-powered-logo"
            role="img"
            aria-label="iWORKKZ"
            style={{
              WebkitMaskImage: `url("${iworkkzWordmark}")`,
              maskImage: `url("${iworkkzWordmark}")`,
            }}
          />
        </div>
      </div>
 
      {/* PROFILE */}
      <button
        type="button"
        className="profile-avatar"
        onClick={() => navigate(`${basePath}/profile`)}
        aria-label="Profile"
      >
        <UserAvatar
          key={`${companyId}/${user?.user_id}`}
          userId={user?.user_id}
          companyId={companyId}
          name={employeeName}
        />
      </button>
    </header>
  );
};
 
export default Header;
